import { ISubscription } from '@sdk/contracts';
import { Select } from 'antd';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export type SubscriptionsSelectorProps = {
  subscriptions: ISubscription[] | undefined;
  value?: string[];
  onChange?: (value: string[]) => void;
  onSelectStore?: (ids: string[]) => void;
  placeholder?: string;
  style?: React.CSSProperties;
  mode?: 'multiple' | 'tags';
  maxTagCount?: number | 'responsive';
  suffixIcon?: React.ReactNode;
};

export const SubscriptionsSelector: React.FC<SubscriptionsSelectorProps> = ({
  subscriptions,
  value,
  onChange,
  onSelectStore,
  placeholder,
  style,
  mode = 'multiple',
  maxTagCount = 0,
  suffixIcon
}) => {
  const { t } = useTranslation('StudentDashboardTranslations');

  const options = useMemo(
    () =>
      subscriptions?.map(sub => ({
        label: sub.course.name,
        value: sub._id
      })),
    [subscriptions]
  );

  const handleChange = (ids: string[]) => {
    onChange?.(ids);
    onSelectStore?.(ids);
  };

  return (
    <Select
      mode={mode}
      allowClear
      showSearch
      style={style}
      placeholder={placeholder ?? t('COURSES')}
      options={options}
      value={value}
      onChange={handleChange}
      suffixIcon={suffixIcon}
      maxTagCount={maxTagCount}
      maxTagPlaceholder={omitted => `+${omitted.length}`}
      filterOption={(input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
      }
    />
  );
};
